import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import { useTheme } from "@emotion/react";
import PrintData from "../../../components/common/section/printData";

const ViewSubsectionDescription = ({
  fetchContentData,
  subsection,
  section,
  language,
}) => {
  const [content, setContent] = useState(null);
  const [error, setError] = useState(null);
  const theme = useTheme();

  useEffect(() => {
    const fetchData = async () => {
      try {
        setError(null); // Reset error state
        const response = await fetchContentData({
          subsection: subsection.subsection,
          section,
          language,
        });

        if (response && response.data) {
          console.log("Fetched content:", response.data);
          setContent(response.data); // Set the description data directly
        } else {
          setContent(null);
        }
      } catch (err) {
        console.error("Error fetching content data:", err);
        setError("Failed to load content.");
      }
    };

    fetchData();
  }, [subsection, section, language, fetchContentData]);

  // Function to clean the description text by removing unwanted characters
  const cleanText = (text) => {
    if (!text) return "";
    return text
      .replace(/^\*+|\*+$/g, "") // Remove leading and trailing asterisks (***)
      .replace(/[“”]/g, "") // Remove curly quotes
      .replace(/\s{2,}/g, " ")
      .trim();
  };

  return (
    <Box sx={{ position: "relative" }}>
      <Box
        sx={{
          position: "sticky",
          top: 0,
          zIndex: 10,
          backgroundColor: "white",
          padding: "10px",
          paddingBottom: "30px",
        }}
      >
        <PrintData fileName={`${subsection.subsection}.pdf`} />
      </Box>
      <Box sx={{ padding: "20px", borderBottom: "2px solid #D3D3D3", }}>
        {error ? (
          <Typography variant="body1" color="error">
            {error}
          </Typography>
        ) : content ? (
          <>
            {/* Title */}
            <Typography
              variant="h1"
              gutterBottom
              sx={{ fontWeight: "bold", color: theme.palette.text.primary }}
            >
              {content.title || subsection.subsection}
            </Typography>

            {/* Data */}
            <Typography
              variant="body1"
              sx={{
                marginBottom: "16px",
                fontSize: "1.3rem",
                lineHeight: "1.5",
                color: theme.palette.text.secondary,
              }}
            >
              {cleanText(content)}
            </Typography>
          </>
        ) : (
          <Typography
            variant="body1"
            sx={{
              fontSize: "1.2rem",
              marginLeft: "20px",
            }}
          >
            Loading content...
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export { ViewSubsectionDescription };
